import { Card, Col, Row, Select } from 'antd';
import { useSelect } from '@refinedev/antd';
import type { PublisherListOut } from '@/api/generated/schemas';
import type { SettlementStatsFilters } from './filters';

type Props = {
  value: SettlementStatsFilters;
  onChange: (next: SettlementStatsFilters) => void;
};

// Wspólny filtr taba rozliczeń — wydawca zawęża KPI, rankingi i oba trendy
// (live/system_health nie przyjmują filtrów po stronie API).
export const SettlementFiltersBar = ({ value, onChange }: Props) => {
  const { selectProps } = useSelect<PublisherListOut>({
    resource: 'user_catalog.publishers',
    optionLabel: 'name',
    optionValue: 'id',
    onSearch: (search) => [{ field: 'q', operator: 'contains', value: search }],
  });

  return (
    <Card size="small">
      <Row gutter={[12, 12]}>
        <Col xs={24} sm={12} lg={8}>
          <Select
            allowClear
            showSearch
            filterOption={false}
            options={selectProps.options}
            onSearch={selectProps.onSearch}
            placeholder="Wydawca (wszyscy)"
            value={value.publisher_id}
            onChange={(v) =>
              onChange({ ...value, publisher_id: (v as number) ?? undefined })
            }
            style={{ width: '100%' }}
          />
        </Col>
      </Row>
    </Card>
  );
};
